<style src="./MoneyboxSmall.scss" lang="scss"></style>
<template lang="html">
  <div
    class="cp1-component"
    :class="{'valid-fail': !isValid}">

    <input
      type="text"
      class="cp1-small-textbox moneybox"
      v-model="inputValue"
      v-money="money"
      :placeholder="placeholder"
      @blur="blur"
      :autofocus="autofocus"
      v-debounce="debounce"
      @debounced="emitDebounce">
  </div>
</template>

<script>
import {DebounceDirective} from '../helpers/debounce/Debounce'
import {VMoney} from 'v-money'
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin.js'

export default {
  name: 'Moneybox',
  mixins: [
    ValidationMixin
  ],
  directives: {
    debounce: DebounceDirective,
    money: VMoney
  },
  props: {
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    autofocus: {
      default: false
    },
    debounce: {
      default: 300
    },
    precision: {
      default: 2
    }
  },
  data () {
    return {
      inputValue: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false /* doesn't work with directive */
      }
    }
  },
  watch: {
    precision: {
      handler (pValue) {
        this.money.precision = pValue
      },
      immediate: true
    },
    inputValue (pValue, pOldValue) {
      if (pValue !== pOldValue) this.$emit('input', pValue)
    },
    value (pValue) {
      this.refreshValues()
    }
  },
  mounted () {
    this.refreshValues()
  },
  methods: {
    refreshValues () {
      this.inputValue = this.value
    },
    blur () {
      this.$emit('blur')
      this.runValidation()
    },
    emitDebounce () {
      this.$emit('debounce', this.inputValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/moneybox-small/MoneyboxSmall.vue